import {get, post, patch, postFormData, patchFormData} from "@/lib/fetcher";

/**
 * Fetch all terms
 * @param {Object} params - Optional query parameters (e.g., { term_group_ids: "1,2,3" })
 */
export async function getTerms(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `/admin/terms?${queryString}` : "/admin/terms";
    return await get(url);
}

/**
 * Create a new term
 * @param {Object} data - { name, type, content OR fileUrl }
 */
export async function postTerm(data) {
    return await postFormData("/admin/terms",  data );
}

/**
 * Update a term by ID
 * @param {string|number} id
 * @param {Object} data - fields to update
 */
export async function patchTerm(id, data) {
    return await patchFormData("/admin/terms", id, data );
}

/**
 * Fetch all BoldSign templates
 */
export async function getBoldSignTemplates() {
    return await get("/admin/bold_sign/list_templates");
}

/**
 * Sync BoldSign templates from BoldSign API
 */
export async function syncBoldSignTemplates() {
    return await post("/admin/bold_sign/sync");
}

/**
 * Get BoldSign templates available to a specific candidate
 * @param {string|number} candidateId - Candidate ID
 */
export async function getCandidateAvailableBoldSignTemplates(candidateId) {
    return await get(`/admin/bold_sign/candidate_available_templates?candidate_id=${candidateId}`);
}

/**
 * Get BoldSign templates available to a specific client
 * @param {string|number} clientId - Client ID
 */
export async function getClientAvailableBoldSignTemplates(clientId) {
    return await get(`/admin/bold_sign/client_available_templates?client_id=${clientId}`);
}

/**
 * Update BoldSign template skill assignment  
 * @param {string|number} id - Template ID  
 * @param {Object} data - { skill_id, active }
 */
export async function updateBoldSignTemplate(id, data) {
    // Custom fetch since our route doesn't match the standard patch helper pattern
    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://ramsden-admin.fly.dev/api/v1";
    
    function getCsrfToken() {
        return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    }
    
    const url = `${API_BASE_URL}/admin/bold_sign/${id}/update_template`;
    
    const headers = {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCsrfToken()
    };

    const response = await fetch(url, {
        method: "PATCH",
        headers,
        credentials: "include",
        body: JSON.stringify({ bold_sign_template: data })
    });

    if (!response.ok) {
        throw new Error(`PATCH /admin/bold_sign/${id}/update_template failed with status ${response.status}`);
    }
    
    return await response.json();
}
